module.exports = __webpack_public_path__ + "static/media/Sherlook.95156ae4.svg";